export const TRANSLATION = "TRANSLATION";
export const DARK_MODE = "DARK_MODE";

export function translate(payload) {
  return {
    type: TRANSLATION,
    payload,
  };
}

export function toggleDarkMode(payload) {
  return {
    type: DARK_MODE,
    payload,
  };
}
